// extracted by mini-css-extract-plugin
export default {"prismicTest":"PrismicTestContainer-module_prismicTest__SMs3F"};